import React, { useEffect, useRef } from 'react'
import {
  Wrapper,
  Content,
  Subtitle,
  Title,
  Description,
  Header,
} from './index.styled'
import ScrollDownArrow from 'components/ui/scroll-arrow'
import Logo from 'components/ui/logo'
import { gsap } from 'helpers/gsap'
import { onArrowClick } from '../../helpers/onArrow'

const FullScreenCopy = ({ data, type, className }) => {
  const {
    subtitle,
    title,
    description,
    heroSection,
    heroSectionClassName,
    multiColumn,
    anchorID = '',
  } = data
  console.dir(data)
  const refWrapper = useRef(null)
  const refContent = useRef(null)
  const refTitle = useRef(null)
  const refSubtitle = useRef(null)
  const refDescription = useRef(null)

  useEffect(() => {
    if (heroSection !== true) {
      let gsapContext = gsap.context(() => {
        const mediaQueryAnimation = gsap.matchMedia()
        mediaQueryAnimation.add('(min-width: 1025px)', () => {
          gsap
            .timeline({
              scrollTrigger: {
                trigger: refContent.current,
                start: 'top center+=25%',
                end: 'bottom bottom',
                toggleActions: 'play none none reverse',
              },
            })
            .from(
              refSubtitle.current,
              {
                yPercent: '15',
                duration: 1,
                opacity: 0,
              },
              0,
            )
            .from(
              refTitle.current,
              {
                yPercent: '25',
                duration: 1,
                opacity: 0,
              },
              0,
            )
            .from(
              refDescription.current,
              {
                yPercent: '25',
                duration: 1,
                opacity: 0,
              },
              0,
            )
        })
      }, refWrapper)

      return () => gsapContext.revert()
    }
  }, [])

  return (
    <>
      <Wrapper
        className={[className, ' fullscreen-copy-section']}
        ref={refWrapper}
        $background={type}
        id={anchorID}
      >
        <Content ref={refContent} $multiColumn={multiColumn}>
          <Header $multiColumn={multiColumn}>
            <Subtitle ref={refSubtitle}>{subtitle}</Subtitle>
            <Title ref={refTitle}>{title}</Title>
          </Header>
          <Description ref={refDescription} $multiColumn={multiColumn}>
            {description}
          </Description>
          {heroSection && (
            <>
              <Logo className={heroSectionClassName} />

              <ScrollDownArrow
                onClick={onArrowClick}
                className={heroSectionClassName}
              />
            </>
          )}
        </Content>
      </Wrapper>
    </>
  )
}

export default FullScreenCopy
